/**
 * Sets a specified select to a given value and disables it when target input is checked/true
 *
 * Values:
 *   optionId    - The value to set on the select when toggled on
 *   optionLabel - (optional) The display text for the option. Required when the
 *                 controlled select uses remote search (e.g., filterrific-remote-select)
 *                 so the option can be added before selecting it.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    optionId: String,
    optionLabel: String,
  };

  static targets = ["toggleInput", "controlledSelect", "hiddenInput"];

  connect() {
    this.toggleInputTarget.checked = this.controlledSelectTarget.value == this.optionIdValue;

    this.toggleInputTarget.addEventListener("change", () => {
      this.toggle();
    });
    this.controlledSelectTarget.addEventListener("change", () => {
      this.toggleInputTarget.checked = this.controlledSelectTarget.value == this.optionIdValue;
    });
  }

  toggle() {
    const enabled = this.toggleInputTarget.checked;
    const ts = this.controlledSelectTarget.tomselect;

    if (ts) {
      if (enabled) {
        // For remote-search selects, ensure the option exists before selecting it
        if (this.optionLabelValue && !ts.options[this.optionIdValue]) {
          ts.addOption({
            id: this.optionIdValue,
            text: this.optionLabelValue,
            value: this.optionIdValue,
          });
        }
        ts.setValue(this.optionIdValue);
      } else {
        ts.setValue("");
      }
    } else {
      this.controlledSelectTarget.value = enabled ? this.optionIdValue : "";
      this.controlledSelectTarget.dispatchEvent(new Event("change"));
    }
  }
}
